import { t as d } from "./index809.mjs";
import { t as l } from "./index876.mjs";
import { l as s } from "./index817.mjs";
var v = d, c = l, x = s, i = function(e) {
  return function(f, n, u) {
    var t = v(f), a = x(t);
    if (a === 0)
      return !e && -1;
    var r = c(u, a), o;
    if (e && n !== n) {
      for (; a > r; )
        if (o = t[r++], o !== o)
          return !0;
    } else
      for (; a > r; r++)
        if ((e || r in t) && t[r] === n)
          return e || r || 0;
    return !e && -1;
  };
}, b = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: i(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: i(!1)
};
export {
  b as a
};
